import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { customComponentRef } from './consts';

export default grapesjs.plugins.add('custom-component', (editor, opts = {}) => {
  let defaults = {
    blocks: [customComponentRef],
    labelCustomComponentCategory: 'Advanced',
    labelCustomComponent: 'Custom Component',
    pfx: 'customComponent',
  };

  for (let name in defaults) {
    if (!(name in opts)) opts[name] = defaults[name];
  }

  loadComponents(editor, opts);
  loadBlocks(editor, opts);
});
